import Cookies from 'js-cookie';
import { SSM_STEP_UP, STEP_UP } from '../helpers/apis';
import { COTTON_SSM_STEP_UP, COTTON_OAUTH_CALLBACK, COTTON_STEP_UP } from '../helpers/cottonApis';
import { isCottonSession as getCottonSession } from '../helpers/featureFlags/cotton';
import { flagEnabled } from '../helpers/featureFlags';
import { kibanaLog } from '../helpers/logger';
import apiClient from '../middleware/apiClient';
import { isTargetAuthEnabled } from '../helpers/auth';
import { NO_CONTACT_ERROR } from '../helpers/routes';
import config from '../config';

export const GET_STEP_UP_LOADING = 'GET_STEP_UP_LOADING';
export const GET_STEP_UP_PERMIT = 'GET_STEP_UP_PERMIT';
export const GET_STEP_UP_FAILURE = 'GET_STEP_UP_FAILURE';

const { cimaClientId, cottonClientId } = config();

/**
 * Dispatches an action when the step up api request is pending
 *
 * @returns {Object} An action object.
 */
function dispatchGetStepUpLoading() {
  return {
    type: GET_STEP_UP_LOADING,
  };
}

/**
 * Dispatches an action to handle the step up api 'permit' response
 *
 * @returns {Object} An action object.
 */
function dispatchGetStepUpPermit() {
  return {
    type: GET_STEP_UP_PERMIT,
  };
}


/**
 * Dispatches an action to handle step up api errors and failures.
 *
 * @param {Error} error - The error object which gets added to the value of payload.
 * @returns {Object} An action object.
 */
function dispatchGetStepUpFailure(error) {
  return {
    type: GET_STEP_UP_FAILURE,
    payload: error,
  };
}

export const stepUp = history => async (dispatch) => {
  dispatch(dispatchGetStepUpLoading());

  const isReplaceSsmStepUpEnabled = flagEnabled('replaceSsmStepUpEnabled');

  try {
    const ssmStepUPEndpoint = isReplaceSsmStepUpEnabled ? STEP_UP : SSM_STEP_UP;
    const cottonStepUPEndpoint = isReplaceSsmStepUpEnabled
      ? COTTON_STEP_UP
      : COTTON_SSM_STEP_UP;
    const isCottonSession = getCottonSession();
    const endpoint = isCottonSession ? cottonStepUPEndpoint : ssmStepUPEndpoint;
    const startTime = performance.now();
    const response = await apiClient.fetch(endpoint);
    const endTime = performance.now();

    if (flagEnabled('enhancedCpcLoggingEnabled')) {
      kibanaLog(`step_up_decision_${response.decision}`, {
        duration: (endTime - startTime) / 1000,
      });
    }

    if (response.decision === 'permit') { // load page
      dispatch(dispatchGetStepUpPermit());
    } else if (response.decision === 'deny') { // redirect
      if (response.reason === 'insufficient_methods_available') {
        kibanaLog('Stepup Received 203 status code with reason insufficient_methods_available');
        history.replace(NO_CONTACT_ERROR);
        return;
      }
      const callbackPath = isCottonSession ? COTTON_OAUTH_CALLBACK : '/oauth/callback';
      const callbackUrl = `${window.origin}${callbackPath}`;
      const oauthRedirectUrl = new URL(response.authorizationBaseUrl);
      const clientId = isCottonSession ? cottonClientId : cimaClientId;
      const currentUrl = new URL(window.location.href);

      currentUrl.searchParams.set('stepup', '1');

      const stateUrl = currentUrl.toString();

      oauthRedirectUrl.searchParams.set('client_id', clientId);
      oauthRedirectUrl.searchParams.set('response_type', 'code');
      oauthRedirectUrl.searchParams.set('redirect_uri', callbackUrl);
      oauthRedirectUrl.searchParams.set('state', stateUrl);
      if (isTargetAuthEnabled()) {
        oauthRedirectUrl.searchParams.set('prompt', 'select_billing_account_auto');
      }

      // Only set ui_locales param for Spanish to translate step-up CIMA page
      const langCookie = Cookies.get('lzlang');
      if (langCookie === 'es') {
        oauthRedirectUrl.searchParams.set('ui_locales', langCookie);
      }

      window.location.replace(oauthRedirectUrl.toString());
    } else { // if decision is not explicitly 'permit' or 'deny', is unknown, or is missing
      kibanaLog('Unknown response from Step Up API');
      throw new Error('Unknown response from Step Up API');
    }
  } catch (error) {
    dispatch(dispatchGetStepUpFailure(error));
  }
};
